module.exports = __webpack_public_path__ + "img/lookbook_9_border.6666316c.png";